import type { AutoFetchItemConfig } from './componentDefinition'

type DualAutoFetch = { admin?: AutoFetchItemConfig; storefront?: AutoFetchItemConfig }

/**
 * 根据 appMode 从双 key autoFetch 结构中选取当前环境的配置。
 * 优先取当前 mode 对应的 key，若不存在则 fallback 到另一个 key。
 *
 * 兼容旧版单 key 格式（数据库可能尚未迁移到 dual-key）：
 * 如果传入对象直接包含 `endpoint`，则视为旧格式，直接返回。
 */
export function resolveAutoFetchConfig(
  autoFetch: DualAutoFetch | AutoFetchItemConfig | undefined,
  appMode: string,
): AutoFetchItemConfig | undefined {
  if (!autoFetch) return undefined
  if ('endpoint' in autoFetch && typeof (autoFetch as Record<string, unknown>).endpoint === 'string') {
    return autoFetch as AutoFetchItemConfig
  }
  const dual = autoFetch as DualAutoFetch
  const mode = appMode === 'admin' ? 'admin' : 'storefront'
  return dual[mode] ?? dual[mode === 'admin' ? 'storefront' : 'admin']
}
